import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, BlockType, ValidationMessage, ValidationMessageType, CodeBlock, TibboDataType,
} from '@appblocks/codegeneration/types';


export default class WM2000TempSensor extends BaseFeature {
    constructor() {
        super();
        this.name = 'WM2000EV Temperature Sensor';
        this.id = 'wm2000ev_temp';
        this.devices = ['WM2000EV'];
        this.requirements = ['WM2000EV'];

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/tibbits/tbt29/tbt29.tbh',
            'libraries/tibbits/tbt29/tbt29.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.WORD,
                default: 'WM2000TEMP',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        const currentSocket = Number(this.getSettingValue('SOCKET'));
        const prevSocket = (currentSocket - 1).toString();
        const { project } = this;
        const NAME = this.getSettingValue('NAME');

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'WM2000EV temperature sensor with tibbit 29
    select case tbt29_init("${NAME}",YES,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL_NUM)
        case TBT29_WRONG_MFGID:
            sys.debugprint("DEFAULT_MFGID_INCORRECT"+chr(10)+chr(13))
            sys.halt

        case TBT29_WRONG_DEVID_REVISION:
            sys.debugprint("TBT29_WRONG_DEVID_REVISION"+chr(10)+chr(13))
            sys.halt

        case TBT29_NO_SSI_AVAILABLE:
            sys.debugprint("SSI channel could not be allocated, using bit banging instead."+chr(10)+chr(13))

    end select`,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_CHANNEL_NUM as byte
            `,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_CHANNEL_NUM as byte
            `,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${NAME}_CLK = PL_IO_NUM_1_TX0
const ${NAME}_DATA = PL_IO_NUM_0_RX0
                         `,
        });

        blocks.push({
            location: `var_${NAME}_update`,
            blockType: BlockType.CODE,
            template: `var_${NAME}_update_completed(tbt29_get_c(${NAME}_CHANNEL_NUM))`,
        });


        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/phm/wm2000ev';
    }
}
